// document.addEventListener('click', async function(e) {
//   const button = e.target.closest('.grid-product__add-to-cart');

//   if (!button) return;

//   e.preventDefault();

//   const variantId = button.dataset.variantId;

//   try {
//     const response = await fetch('/cart/add.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify({
//         id: variantId,
//         quantity: 1
//       })
//     });

//     if (response.ok) {

//       button.classList.add('added');
//       button.innerHTML = '✓';

//       setTimeout(() => {

//         button.innerHTML = `
//             <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
//               <path d="M6.36406 12.0139L5.65 12.0139L5.65 6.36399L9.49248e-05 6.36399V5.64993L5.65 5.64993L5.65 2.53939e-05L6.36406 2.56046e-05L6.36406 5.64993L12.014 5.64993V6.36399L6.36406 6.36399L6.36406 12.0139Z" fill="black"/>
//             </svg>
//         `;

//         button.classList.remove('added');

//       }, 1500);

//       document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
//     }

//   } catch (error) {
//     console.log('Add to cart error:', error);
//   }
// });

document.addEventListener('click', async function (e) {

  const addButton = e.target.closest('.grid-product__add-to-cart');

  if (addButton && window.innerWidth <= 768) {

    e.preventDefault();

    const wrapper = addButton.closest('.grid-product__image-mask');
    const selector = wrapper.querySelector('.product-size-selector');
    const overlay = wrapper.querySelector('.size-popup-overlay');

    // CLOSE ALL OTHER POPUPS

    document.querySelectorAll('.product-size-selector').forEach(el => {
      el.classList.remove('active');
    });

    document.querySelectorAll('.size-popup-overlay').forEach(el => {
      el.classList.remove('active');
    });

    // OPEN CURRENT

    selector.classList.add('active');
    overlay.classList.add('active');
    return;
  }

  // CLOSE POPUP OVERLAY

  if (e.target.classList.contains('size-popup-overlay')) {

    const wrapper = e.target.closest('.grid-product__image-mask');

    if (wrapper) {
      wrapper.querySelector('.product-size-selector').classList.remove('active');
    }

    e.target.classList.remove('active');
    return;
  }

  // CLOSE BUTTON CLICK

  const closeButton = e.target.closest('.product-size-popup-close');

  if (closeButton) {

    const wrapper = closeButton.closest('.grid-product__image-mask');
    wrapper.querySelector('.product-size-selector').classList.remove('active');
    wrapper.querySelector('.size-popup-overlay').classList.remove('active');

    return;
  }

  // SIZE CLICK

  const sizeButton = e.target.closest('.product-size-btn');

  if (!sizeButton) return;

  // STOP SOLD OUT

  if (sizeButton.classList.contains('sold-out')) {
    return;
  }

  e.preventDefault();

  // ACTIVE SIZE SELECT

  const allButtons = sizeButton
    .closest('.product-size-selector-inner')
    .querySelectorAll('.product-size-btn');

  allButtons.forEach(btn => {
    btn.classList.remove('active');
  });

  sizeButton.classList.add('active');

  const variantId = sizeButton.dataset.variantId;

  try {

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    });

    if (response.ok) {

      const wrapper = sizeButton.closest('.grid-product__image-mask');
      const addBtn = wrapper.querySelector('.grid-product__add-to-cart');

      addBtn.classList.add('added');
      addBtn.innerHTML = '✓';

      setTimeout(() => {

        addBtn.innerHTML = `
          <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.36406 12.0139L5.65 12.0139L5.65 6.36399L9.49248e-05 6.36399V5.64993L5.65 5.64993L5.65 2.53939e-05L6.36406 2.56046e-05L6.36406 5.64993L12.014 5.64993V6.36399L6.36406 6.36399L6.36406 12.0139Z" fill="black"/>
          </svg>
        `;

        addBtn.classList.remove('added');

      }, 1500);

      // CLOSE POPUP

      wrapper.querySelector('.product-size-selector').classList.remove('active');

      wrapper.querySelector('.size-popup-overlay').classList.remove('active');

      // REFRESH CART

      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));

    }

  } catch (error) {

    console.log('Add to cart error:', error);

  }

});

// CLICK OUTSIDE CLOSE MOBILE

document.addEventListener('click', function (e) {

  if (
    !e.target.closest('.grid-product__image-mask')
    && window.innerWidth <= 768
  ) {

    document.querySelectorAll('.product-size-selector').forEach(el => {
      el.classList.remove('active');
    });

    document.querySelectorAll('.size-popup-overlay').forEach(el => {
      el.classList.remove('active');
    });
  }

});

document.addEventListener('change', function (e) {
  if (e.target.closest('#FilterDrawer')) {
    setTimeout(() => {
      const products = document.querySelectorAll(
        '#CollectionAjaxResult .grid-product'
      );

      const countElement = document.getElementById('CollectionProductCount');

      if (countElement) {
        const count = products.length;

        countElement.innerHTML =
          count + ' ' + (count === 1 ? 'Product' : 'Products');
      }
    }, 700);
  }
});